import { SigninScreen, SignoutScreen } from '@/screens'

export default [
    {
        path: '/auth/signin',
        name: 'Signin',
        component: SigninScreen,
        meta: {
            guest: true,
        },
    },
    {
        path: '/auth/signout',
        name: 'Signout',
        component: SignoutScreen,
        meta: {
            auth: true,
        },
    },
]
